<!--
* @description 诉求量分析弹窗
* @fileName demandDialog.vue
* @author xuesong
* @date 2022/02/08 18:57:01
!-->
<template>
  <div id="DemandDialog">
    <div class="wrapper">
      <div class="header">
        <el-radio-group v-model="type" @change="typeChange">
          <el-radio-button label="诉求总和"></el-radio-button>
          <el-radio-button label="本月受理量"></el-radio-button>
          <el-radio-button label="平均办结时间"></el-radio-button>
          <el-radio-button label="办结率"></el-radio-button>
        </el-radio-group>
        <div class="select">
          <el-select
            v-model="yaer"
            placeholder="请选择"
            style="margin-right: 20px"
          >
            <el-option
              v-for="item in yearOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select v-model="month" placeholder="请选择">
            <el-option
              v-for="item in monthOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div id="barChart" ref="barChart"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'DemandDialog',
  data() {
    return {
      barChart: null,
      type: '诉求总和',
      yaer: '2022年',
      month: '1月',
      monthOptions: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月'
      ],
      yearOptions: ['2022年', '2021年', '2020年'],
      town: [
        '青田县',
        '莲都区',
        '缙云县',
        '遂昌县',
        '松阳县',
        '云和县',
        '庆元县',
        '景宁县',
        '龙泉市',
        '景宁畲族自治县'
      ],
      ydata: [null, null, null, null, null, null, null, null, null, null]
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    typeChange() {
      console.log(this.type)
      this.initChart()
    },
    initChart() {
      this.barChart = echarts.init(this.$refs.barChart)
      const option = this.getOption(this.town, this.ydata, this.type)
      this.barChart.setOption(option, true)
      window.addEventListener('resize', function () {
        this.barChart.resize()
      })
    },
    getOption(xdata, ydata, type) {
      const options = {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#84FFF7' // 0% 处的颜色
            },
            {
              offset: 0.5,
              color: '#6DFFF7' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(0,255,247,0.2)' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        },
        grid: {
          containLabel: true,
          top: '10',
          left: '20',
          bottom: '20%'
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        legend: {
          show: true,
          right: '45%',
          bottom: 30,
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xdata,
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 14,
            interval: 0
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
              opacity: 0.5
            }
          }
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            left: '9%',
            bottom: -5,
            start: 10,
            end: 90, // 初始化滚动条
            textStyle: {
              color: '#fff'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.65)',
              fontSize: 10
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                opacity: 0.5,
                width: 0.3
              }
            }
          }
        ],
        series: [
          {
            name: type,
            data: ydata,
            type: 'bar',
            barWidth: 10
          }
        ]
      }
      return options
    }
  }
}
</script>
<style lang='scss' scoped>
#DemandDialog {
  width: 100%;
  height: 100%;
  .wrapper {
    width: 100%;
    height: 100%;
  }
  .header {
    /deep/ .el-radio-button__inner {
      color: rgba(255, 255, 255, 0.45);
      background-color: rgba(11, 24, 35, 1);
      border: 1px solid rgba(45, 56, 75, 1);
    }
    /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #fff !important;
      background-color: rgba(0, 137, 255, 0.2);
      border: 1px solid rgb(37, 153, 255) !important;
    }
    /deep/ .el-select-dropdown .el-popper {
      z-index: 99999 !important;
    }
    .select {
      padding-top: 0.15rem;
      text-align: right;
      /deep/ .el-select {
        width: 1.5rem;
        margin-right: 0.2rem;
        .el-input__inner {
          height: 0.32rem;
          color: rgba(255, 255, 255, 100);
          background-color: rgba(11, 24, 35, 1);
          border: 1px solid rgba(45, 56, 75, 1);
        }
        .el-input--medium .el-input__icon {
          line-height: 0.32rem;
        }
      }
    }
  }
  #barChart {
    width: 100%;
    height: 70%;
  }
}
</style>
